export default __webpack_public_path__ + "static/media/translateIcon.3886e26f.svg";